import { create } from "zustand";
import type { LLMModel } from "../services/client/api";
import { DEFAULT_INPUT_TEMPLATE, DEFAULT_MODELS } from "../constant";

export type ModelType = (typeof DEFAULT_MODELS)[number]["name"];

export enum SubmitKey {
  Enter = "Enter",
  CtrlEnter = "Ctrl + Enter",
  ShiftEnter = "Shift + Enter",
  AltEnter = "Alt + Enter",
  MetaEnter = "Meta + Enter",
}

export enum Theme {
  Auto = "auto",
  Dark = "dark",
  Light = "light",
}

export const DEFAULT_CONFIG = {
  submitKey: SubmitKey.Enter as SubmitKey,
  avatar: "1f603",
  fontSize: 18,
  theme: Theme.Auto as Theme,
  tightBorder: false,
  sendPreviewBubble: false,
  sidebarWidth: 300,

  disablePromptHint: false,

  dontShowMaskSplashScreen: false, // dont show splash screen when create chat

  models: DEFAULT_MODELS as any as LLMModel[],

  modelConfig: {
    model: "gpt-3.5-turbo" as ModelType,
    temperature: 0.01,
    top_p: 1,
    max_tokens: 2000,
    presence_penalty: 0,
    frequency_penalty: 0.7,
    sendMemory: true,
    historyMessageCount: 10,
    compressMessageLengthThreshold: 1000,
    template: DEFAULT_INPUT_TEMPLATE,
  },
};

export const ALL_MODELS = [{ name: "gpt-3.5-turbo" }];

export type ChatConfig = typeof DEFAULT_CONFIG;

export type ModelConfig = ChatConfig["modelConfig"];

export const useAppConfig = create<ChatConfig>()((set, get) => ({
  ...DEFAULT_CONFIG,
}));
